import { render, staticRenderFns } from "./UsersCRUD.vue?vue&type=template&id=11e9cfe2&"
import script from "./UsersCRUD.vue?vue&type=script&lang=js&"
export * from "./UsersCRUD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports